import A from '../data/ASSUMPTIONS';

const calcDieselGallonsFromKwh = (kwh) =>
  (kwh * A.ENERGY_DENSITY_ELECTRICITY_IN_MJ_PER_KWH) / A.ENERGY_DENSITY_DIESEL_IN_MJ_PER_GAL;
export default calcDieselGallonsFromKwh;
